import { useEffect } from 'react';
import { useUi } from '@/lib/ui';

function isTyping(e: KeyboardEvent) {
  const el = e.target as HTMLElement | null;
  if (!el) return false;
  return el.isContentEditable || el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT';
}

/** App-wide keyboard shortcuts. */
export function useGlobalShortcuts() {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      const mod = e.ctrlKey || e.metaKey;
      if (mod && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        useUi.setState((s) => ({ commandOpen: !s.commandOpen }));
        return;
      }
      if (isTyping(e) || mod || e.altKey) return;
      if (e.key === 't') {
        e.preventDefault();
        useUi.setState({ createTaskOpen: true });
      } else if (e.key === '/') {
        e.preventDefault();
        useUi.setState({ commandOpen: true });
      } else if (e.key === '?') {
        e.preventDefault();
        useUi.setState({ shortcutsOpen: true });
      } else if (e.key === '[' ) {
        useUi.setState((s) => ({ sidebarCollapsed: !s.sidebarCollapsed }));
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);
}
